import {
  Button, Details, TextInput,
} from 'nhsuk-react-components';
import { useState } from 'react';
import { NotifyRoutingPlan } from 'schemas/NotifyRoutingPlan.schema';
import NotifyRoutingPlansTable from './NotifyRoutingPlansTable';

interface IAdminRoutingLegacyPlansSectionProps {
  notifyRoutingPlans: NotifyRoutingPlan[];
  onDeletePlan: (plan: NotifyRoutingPlan) => void;
  onAddLegacyPlan: (planName: string) => void;
}

function AdminRoutingLegacyPlansSection({
  notifyRoutingPlans,
  onDeletePlan,
  onAddLegacyPlan,
}: IAdminRoutingLegacyPlansSectionProps) {
  const [legacyPlanName, setLegacyPlanName] = useState('');

  const handleAddLegacyPlan = (): void => {
    const trimmedPlanName = legacyPlanName.trim();

    if (!trimmedPlanName) {
      return;
    }

    onAddLegacyPlan(trimmedPlanName);
    setLegacyPlanName('');
  };

  return (
    <Details expander>
      <Details.Summary>
        Add legacy plans
      </Details.Summary>
      <Details.Text>
        <p>
          Add legacy plans here. Legacy plans use the older
          {' '}
          <b>Routing Plan</b>
          {' '}
          format and aren&apos;t included in the new
          {' '}
          <b>NHS Notify Message Plans</b>
          {' '}
          table.
        </p>
        <p>
          You only need to add legacy plans if you&apos;re still using them. Otherwise, you can leave this section empty.
        </p>

        <TextInput
          placeholder="Add your legacy plans here."
          value={legacyPlanName}
          onChange={(event) => setLegacyPlanName(event.target.value)}
        />
        <Button secondary onClick={handleAddLegacyPlan}>
          Add legacy plan
        </Button>
        {notifyRoutingPlans.length > 0 && (
          <NotifyRoutingPlansTable
            routingPlans={notifyRoutingPlans}
            onDelete={onDeletePlan}
          />
        )}
      </Details.Text>
    </Details>
  );
}
export default AdminRoutingLegacyPlansSection;
